<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    <div class="w-full flex flex-col h-full overflow-hidden">
        <div class="shrink-0 sm:flex sm:items-center pb-2">
            <div class="sm:flex-auto">
                <h1 class="text-base font-semibold text-primary">Products</h1>
                <p class="mt-2 text-sm text-secondary">A list of all the products available for promotion.</p>
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex sm:flex-row gap-x-2">

                <button *hasBoltOn="[environment.stripe.shaas21products.bo_gifting_seeding]" type="button" (click)="goToRakutenProducts('find')"
                    class="block secondary-button text-primary">Rakuten</button>

                <button type="button" (click)="openCreateProductModal()"
                    class="block rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Add
                    product</button>
            </div>
        </div>

        @if (allProducts() && allProducts()!.length > 0) {
        <div class="flex-1 flex-col items-center justify-center w-full overflow-hidden">
            <div class="grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 h-full overflow-y-auto scrollbar-transparent">
                @for (product of allProducts(); track product.id) {
                <div>
                    <div class="relative">
                        <div class="relative h-72 w-full overflow-hidden rounded-lg">
                            <img [src]="imageService.getImageSource(product.productImage, 'gallery_xl')"
                                alt="No image available"
                                class="size-full object-cover" />
                        </div>
                        <div class="relative mt-4">
                            <h3 class="text-sm font-medium text-primary">{{ product.productName }}</h3>
                            <p class="mt-1 text-sm text-secondary">{{
                                getProductTypeName(product.productType)
                                }}</p>
                        </div>
                        <div
                            class="absolute inset-x-0 top-0 flex h-72 items-end justify-end overflow-hidden rounded-lg p-4">
                            <div aria-hidden="true"
                                class="absolute inset-x-0 bottom-0 h-36 bg-linear-to-t from-black opacity-100"></div>

                            @if (product.productType !== 2) {
                            <button type="button" (click)="openEditProduct(product)"
                                class="absolute top-2 right-2 z-10 text-primary tertiary-button">Edit</button>
                            } @else {
                            <span class="absolute top-2 right-2 z-10 rounded-md px-2 py-1 text-xs text-secondary bg-black/40"
                                title="Editing mobile apps from this list is not available yet">Edit unavailable</span>
                            }

                            <p class="relative text-lg font-semibold text-white">{{ ((product.productValue ?? 0) / 100) |
                                currency:
                                product.currency ? product.currency.toUpperCase() : 'GBP' }}</p>
                        </div>
                    </div>
                </div>
                }

            </div>
        </div>
        } @else if (allProducts() && allProducts()!.length === 0) {
            <div class="mt-12 flex flex-col items-center justify-center py-12 px-4">
                <div class="max-w-lg text-center">
                    <div class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/15">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-8 text-accent">
                            <path
                                d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                            <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                            <path d="m14 20 2 2 4-4" />
                        </svg>
                    </div>
                    <h3 class="mt-6 text-lg font-semibold text-primary">No products yet</h3>
                    <p class="mt-3 text-sm leading-6 text-secondary">
                        Add products to help creators understand exactly what they'll be promoting when you post a brief.
                    </p>
                    <div class="mt-8">
                        <button type="button" (click)="openCreateProductModal()"
                            class="inline-flex items-center gap-x-2 rounded-md bg-primary dark:bg-primary px-4 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 dark:hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                            Add Your First Product
                        </button>
                    </div>
                </div>
            </div>
        } @else {
            <div class="mt-8">
                <p class="text-sm text-primary">Loading products...</p>
            </div>
        }

    </div>
</div>

@if (showCreateProductModal()) {
<mb-brand-products-create [selectedProduct]="productToEdit()"
    (close)="closeProductModal()"
    (productAdded)="onProductAdded($event)"
    (productAmended)="onProductAmended($event)"></mb-brand-products-create>

    <!-- <mb-brand-products-drawer (close)="showCreateProductModal.set(false)"></mb-brand-products-drawer> -->
}